import { SettlementStatusEnum } from "@saleor/types/globalTypes";
import Moment from "moment";

export function InvalidThreeMonth(dateFrom, dateTo) {
  // check if order date range is invalid and not greater than 3 months
  if (
    Moment(dateFrom).isAfter(dateTo) ||
    Moment(dateTo).diff(dateFrom, "days") > 90
  ) {
    return true;
  } else {
    return false;
  }
}

export const getMoment = (format: string, condition: number = 0) =>
  Moment(new Date())
    .add(condition, "days")
    .format(format);

export const hasAppliedFilters = params => {
  const {
    brand,
    isPayoutEligible,
    orderCompleteDateTo,
    orderCompleteDateFrom,
    paymentMethodType,
    query
  } = params;
  if (
    brand ||
    isPayoutEligible ||
    orderCompleteDateTo ||
    orderCompleteDateFrom ||
    paymentMethodType ||
    query
  ) {
    return true;
  } else {
    return false;
  }
};

export const formatDateWithTime = (date: string) =>
  Moment.utc(date)
    .local()
    .format("YYYY-MM-DDTHH:mm");

export function checkSettlementStatus(status: SettlementStatusEnum) {
  switch (status) {
    case SettlementStatusEnum.EXCLUDED:
      return SettlementStatusEnum.EXCLUDED;
    case SettlementStatusEnum.FOR_PAYMENT:
      return SettlementStatusEnum.FOR_PAYMENT;
    default:
      return "";
  }
}
